import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, ModalBody, Button } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import backlogo from '../../Assets/App_icon/back.png';

const NotifyMaster = () => {
  
  const store = localStorage.getItem('store');
  const host_url = localStorage.getItem('host_url');
  

  const navigate = useNavigate();
  const [modalVisible, setModalVisible] = useState(false); 
  const [custModalVisible, setCustModalVisible] = useState(false); 
  const [wModalVisible, setWModalVisible] = useState(false); 
  
  const [areas, setAreas] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState([]);

  const [gMsg, setGMsg] = useState('');
  const [eMsg, setEMsg] = useState('');
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageBase64, setImageBase64] = useState('');
  const [imageMimeType, setImageMimeType] = useState('');
  const [imageFilename, setImageFilename] = useState('');
 
  const [chekedCust, setChekedCust] = useState([]);
  const [chekedNotify, setChekedNotify] = useState([]);
 
  

  const handleBack = () => {
    navigate('../dashboard');
  };

    useEffect(() => { 
      const fetchAreaList = async () => { 
          
          try {
            const response = await fetch(`${host_url}/area_list`, {
              method: 'POST', 
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                type: 'list',
                store: store,
                areaId : '',
                areaName: '',
                areaEName: '',
              }),
            });
            const data = await response.json();
            setAreas(data);
          } catch (error) {
            console.error('Error fetching cities:', error);
          }
          
      }; 
     fetchAreaList(); 
    }, [host_url, customers]);


    // Escape key press handling
    useEffect(() => {
      const handleKeyPress = (event) => {
        if (event.key === "Escape") {
          // Close modal or navigate back if no modal is open
          if (modalVisible || custModalVisible || wModalVisible) {
            setModalVisible(false);
            setCustModalVisible(false);
            setWModalVisible(false);
          } else {
            handleBack();
          }
        }
        
      };

      document.addEventListener("keydown", handleKeyPress);
      return () => {
        document.removeEventListener("keydown", handleKeyPress);
      };
    }, [modalVisible, custModalVisible, wModalVisible]);

    useEffect(() => { 
      const fetchCustList = async () => { 
          try {
            const response = await fetch(`${host_url}/cust_mlist`, {
              method: 'POST', 
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                type: 'list',
                store: store,
                custId: '',
                custMo: '',
                custName: '',
                custEName: '',
                custAreaId: '',
                custAdd: '',
                custEAdd: '',
                custVerify: '',
                custRefno: '', 
              }),
            });
            const data = await response.json();
            console.log(data);
            setCustomers(data);
          } catch (error) {
            console.error('Error fetching cities:', error);
          }
          
      }; 
     fetchCustList(); 
    }, [host_url, ]); // Fetch Customer Detail 

    useEffect(() => {
      setChekedNotify(chekedCust);
    }, [chekedCust]); // Customer Checked

    const handleCustDetail = (cust) => {
      setCustModalVisible(true);
      setSelectedCustomer(cust);
    };
    
    const [custIdFilter, setCustIdFilter] = useState('');
    const [custMoFilter, setCustMoFilter] = useState('');
    const [custNameFilter, setCustNameFilter] = useState('');
    const [custEAddFilter, setCustEAddFilter] = useState('');
    const [custAreaFilter, setCustAreaFilter] = useState('');
    const [custStatusFilter, setCustStatusFilter] = useState('');
    const [startOrder, setStartOrder] = useState('');
    const [endOrder, setEndOrder] = useState('');
    const [startLogin, setStartLogin] = useState('');
    const [endLogin, setEndLogin] = useState('');

    const filteredCustomers = customers.filter(customers =>
      String(customers.custId).toLowerCase().includes(custIdFilter.toLowerCase()) &&
      String(customers.custMo).toLowerCase().includes(custMoFilter.toLowerCase()) &&
      customers.custEName.toLowerCase().includes(custNameFilter.toLowerCase()) &&
      customers.custEAdd.toLowerCase().includes(custEAddFilter.toLowerCase()) &&
      customers.custAreaEName.toLowerCase().includes(custAreaFilter.toLowerCase()) &&
      customers.custLang.toLowerCase().includes(custStatusFilter.toLowerCase()) &&
      (!startOrder || customers.custLastOrder >= startOrder) &&  (!endOrder || customers.custLastOrder <= endOrder) &&
      (!startLogin || customers.custLastLogin >= startLogin) &&  (!endLogin || customers.custLastLogin <= endLogin) 
      
    );

    const totalCount = filteredCustomers.length;
    
    const handleCheckboxChange = (e, row, isChecked) => {
      if (isChecked) {
        setChekedCust([...chekedCust, row]);
      } else {
        setChekedCust(chekedCust.filter(cust => cust.custId !== row.custId));
      }
    };

    const handleSelectAllChange = (e) => {
      const isChecked = e.target.checked;
      
      if (isChecked) {
        setChekedCust(filteredCustomers);
      } else {
        // Deselect all checkboxes
        setChekedCust([]);
      }
    };

    // Function to send the push token to your server
      const sendPushTokenToServer = async () => {
        setModalVisible(false)
        const BATCH_SIZE = 10;
        const DELAY_MS = 10;

        // Helper function to delay execution
        const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

        // Split array into chunks
        const chunkArray = (array, size) => {
          const chunks = [];
          for (let i = 0; i < array.length; i += size) {
            chunks.push(array.slice(i, i + size));
          }
          return chunks;
        };

        // Prepare customer list
        const custList = chekedNotify.map(customer => ({
          custLang: customer.custLang,
          custName: customer.custName,
          custEName: customer.custEName,
          custPNTokenId: customer.custPNTokenId
        }));

        const custChunks = chunkArray(custList, BATCH_SIZE);

        for (let i = 0; i < custChunks.length; i++) {
          const currentChunk = custChunks[i];

          try {
            const response = await fetch(`${host_url}/bulk_notify`, {
              method: 'POST',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                gMsg: gMsg,
                eMsg: eMsg,
                custList: currentChunk,
              }),
            });

            console.log(`Batch ${i + 1} response:`, response);
            if (response.ok) {
              console.log(`Batch ${i + 1} sent successfully.`);
            } else {
              console.warn(`Batch ${i + 1} failed.`);
            }

          } catch (error) {
            console.error(`Error in batch ${i + 1}:`, error);
          }

          if (i < custChunks.length - 1) {
            await delay(DELAY_MS); // Wait before sending the next batch
          }
        }

        alert('All notifications have been processed.');
      };

    // HAndle Image  
      const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
          setSelectedImage(file);
          const reader = new FileReader();
          reader.onloadend = () => {
            const base64String = reader.result.split(',')[1]; // Remove data:image/...;base64,
            setImageBase64(base64String);
            setImageMimeType(file.type);
            setImageFilename(file.name);
          };
          reader.readAsDataURL(file);
        }
      };

    // Function to send WhatsApp Msg to your server
      const sendWMsgToServer = async () => {
        setWModalVisible(false);

        // Prepare customer list
        const custList = chekedNotify.map(customer => ({
          custLang: customer.custLang,
          custName: customer.custName,
          custEName: customer.custEName,
          custMo: customer.custMo
        }));

        try {
          const response = await fetch(`${host_url}/whatsapp/send-message`, {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              gMsg: gMsg,
              eMsg: eMsg,
              custList: custList,
              imageBase64: imageBase64,
              imageMimeType: imageMimeType,
              imageFilename: imageFilename
            }),
          });

          if (response.ok) {
            console.log('WhatsApp Message sent successfully.');
            setSelectedImage(null);
            setGMsg('');
            setEMsg('');
            setImageBase64('');
            setImageMimeType('');
            setImageFilename('');
            alert('WhatsApp Message sent successfully.');
          } else {
            console.warn('Failed to send WhatsApp Message.');
            alert('Failed to send WhatsApp Message.');
          }
        } catch (error) {
          console.error('Error sending WhatsApp Message:', error);
          alert('Error occurred while sending WhatsApp Message.');
        }
      };


  return (
    <div className="container">
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              <div onClick={handleBack}>
                <img src={backlogo} alt="Back" className='system-icon'/>
              </div>
              <b style={{ margin: '10px', fontSize: '20px' }}>Notification Master</b>
              <div ></div>
          </div>
         
        
          <table className="table-bordered table-sm custom-hover">
            <thead>
              <tr >
                <th><span style={{ display: 'flex', paddingLeft: '10px' }}>
                      <span>
                        <input
                          type="checkbox"
                          value="selectAll"
                          onChange={(e) => handleSelectAllChange(e)}
                        />
                      </span>
                      <span style={{ paddingLeft: '10px' }}>Cust Id</span>
                    </span>
                </th>
                <th>Mobile</th>
                <th colSpan='2'>
                  <input
                    type="text"
                    className="search-input"
                    value={custNameFilter}
                    onChange={(e) => setCustNameFilter(e.target.value)}
                    placeholder="Search By Name"
                  />
                </th>
                <th colSpan='2'>Area</th>
                <th>Platform</th>
                <th>last Order</th>
                <th>last Login</th>
              </tr>
              <tr>
                 <th>
                  <input
                    type="text"
                    className="search-input"
                    value={custIdFilter}
                    onChange={(e) => setCustIdFilter(e.target.value)}
                  />
                </th>
                <th>
                  <input
                    type="text"
                    className="search-input"
                    value={custMoFilter}
                    onChange={(e) => setCustMoFilter(e.target.value)}
                  />
                </th>
                <th colSpan='2'>
                  <input
                    type="text"
                    className="search-input"
                    value={custEAddFilter}
                    onChange={(e) => setCustEAddFilter(e.target.value)}
                    placeholder="Search By Address"
                  />
                </th>
                <th colSpan='2'>
                  <select
                    className="search-input"
                    value={custAreaFilter}
                    onChange={(e) => setCustAreaFilter(e.target.value)}
                  >
                    <option value="">All Status</option>
                    {areas.map((area) => (
                      area.customer > 0 && (
                        <option key={area.areaId} value={area.areaEName}>
                          {area.areaEName}
                        </option>
                      )
                    ))}
                  </select>
                </th>
                <th>
                  <select
                    className="search-input"
                    value={custStatusFilter}
                    onChange={(e) => setCustStatusFilter(e.target.value)}
                  >
                    <option value="">All Platform</option>
                    <option value="Gujarati">Gujarati</option>
                    <option value="English">English</option>
                  </select>
                </th>
                <th> 
                  <div style={{ display: 'flex', justifyContent: 'space-between'}}>
                      <input
                        type="text"
                        className="search-input"
                        style={{ width: '45%', textAlign: 'center' }}
                        value={startOrder}
                        onChange={(e) => setStartOrder(e.target.value)}
                      />
                      <input
                        type="text"
                        className="search-input"
                        style={{ width: '45%', textAlign: 'center' }}
                        value={endOrder}
                        onChange={(e) => setEndOrder(e.target.value)}
                      />
                  </div>    
                </th>
                <th> 
                  <div style={{ display: 'flex', justifyContent: 'space-between'}}>
                      <input
                        type="text"
                        className="search-input"
                        style={{ width: '45%', textAlign: 'center' }}
                        value={startLogin}
                        onChange={(e) => setStartLogin(e.target.value)}
                      />
                      <input
                        type="text"
                        className="search-input"
                        style={{ width: '45%', textAlign: 'center' }}
                        value={endLogin}
                        onChange={(e) => setEndLogin(e.target.value)}
                      />
                  </div>    
                </th>
              </tr>
            </thead>
            <tbody className="scrollable-body">
              {filteredCustomers.map((row) => {
                  return (
                    <tr key={row.custId} style={{ lineHeight: '10px', cursor: 'default' }} >
                      
                      <td onClick={(e) => {
                        e.stopPropagation();  
                        const checkbox = e.target.querySelector('input[type="checkbox"]');
                        if (checkbox) {
                          checkbox.checked = !checkbox.checked;
                          handleCheckboxChange(e, row, checkbox.checked);
                        }
                      }}>
                        <span style={{ display: 'flex', paddingLeft: '10px' }}>
                          <span>
                            <input
                              type="checkbox"
                              value={row.custId}
                              checked={chekedCust.some(order => order.custId === row.custId)}
                              onChange={(e) => handleCheckboxChange(e, row, e.target.checked)}
                            />
                          </span>
                          <span style={{ paddingLeft: '10px' }} >{row.custId}</span>
                        </span>
                      </td>
                      <td ><span style={{ paddingLeft: '10px' }}>{row.custMo}</span></td>
                      <td colSpan='2' className="cell-left" onClick={() => handleCustDetail(row)} style={{ cursor: 'pointer' }} ><span style={{ paddingLeft: '10px' }} >{row.custEName}</span></td>
                      <td colSpan='2' className="cell-left"><span style={{ paddingLeft: '10px' }}>{row.custAreaEName}</span></td>
                      <td>
                        <span style={{display: 'flex', paddingLeft: '10px'}}>
                          <span style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: row.custPNToken === 'android' ? '#00962d' : '#000000', marginRight: '5px'}}></span>
                          <span>{row.custLang}</span>
                        </span>
                      </td>
                      <td className='cell-right'><span style={{ paddingRight: '10px' }}>{row.custLastOrder}</span></td>
                      <td className='cell-right'><span style={{ paddingRight: '10px' }}>{row.custLastLogin}</span></td>
                    </tr>
                  );
              })}
            </tbody>
            <tfoot>
              <tr >
                <th className="cell-left"><span style={{ paddingLeft: '15px' }}>{totalCount}</span></th>
                <th colSpan='3'>
                    {chekedCust.length > 0  && (
                      <Button color="primary" style={{ marginTop: '5px', marginBottom: '5px', width: '50%', paddingTop: '0px', paddingBottom: '0px', fontSize: '16px' }}  onClick={() => setModalVisible(true)}>Send Notification</Button>
                    )}                     
                </th>
                <th colSpan='3'>
                    {chekedCust.length > 0  && (
                      <Button color="success" style={{ marginTop: '5px', marginBottom: '5px', width: '50%', paddingTop: '0px', paddingBottom: '0px', fontSize: '16px' }}  onClick={() => setWModalVisible(true)}>Whatsapp</Button>
                    )} 
                </th>
                <th></th>
                <th></th>             
              </tr>
            </tfoot>
          </table>
          

          {/* Modal for Notification Detail */}
            <Modal isOpen={modalVisible} toggle={() => setModalVisible(!modalVisible)} className="detailmodal-lg" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                <h5 >Notification Detail</h5>  
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%'}}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '58%', marginRight: '2%', border: '2px solid #dcdcdc'}}>
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th style={{ paddingLeft: '10px' }} >Id</th>
                          <th colSpan='2'style={{ paddingLeft: '10px' }} >Customer Name</th>
                          <th colSpan='2' style={{ paddingLeft: '10px' }} >Area </th>
                        </tr>
                      </thead>
                      <tbody className="scrollable-body">
                          {chekedNotify.map((row, index) => {
                              return (
                                <tr key={index} style={{ lineHeight: '10px' }} >
                                  <td className="cell-left"><span style={{ paddingLeft: '10px' }} >{row.custId}</span></td>
                                  <td colSpan='2' className="cell-left"><span style={{ paddingLeft: '10px', fontSize: '14px' }} >{row.custEName}</span></td>
                                  <td colSpan='2' className="cell-left"><span style={{ paddingLeft: '10px', fontSize: '14px' }}>{row.custAreaEName}</span></td>
                                </tr>
                              );
                          })}
                      </tbody>
                      <tfoot>
                        <tr>
                          <th style={{ paddingLeft: '10px' }} >Total</th>
                          <th colSpan='2' className="cell-left"  style={{ paddingLeft: '10px' }} >{chekedNotify.length}</th>
                          <th colSpan='2' ></th>
                        </tr> 
                      </tfoot>
                    </table>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '40%', border: '2px solid #dcdcdc'}}>
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                      <tbody>
                        <tr>
                          <td className="cell-left">Gujarati</td>
                          <td className="cell-left">
                            <textarea 
                              value={gMsg} 
                              onChange={(e) => setGMsg(e.target.value)} 
                              rows="5" 
                            />
                          </td>
                        </tr>
                        <tr>
                          <td className="cell-left">English</td>
                          <td className="cell-left">
                            <textarea 
                              value={eMsg} 
                              onChange={(e) => setEMsg(e.target.value)} 
                              rows="5" 
                            />
                          </td>
                        </tr>
                        
                        <tr>
                          <td colSpan='2'>
                            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                <Button color="success" style={{ flex: 1, marginLeft: '10px', marginRight: '10px'}} onClick={sendPushTokenToServer}>
                                  Send
                                </Button>
                                <Button color="primary" style={{ flex: 1, marginLeft: '10px', marginRight: '10px' }} onClick={() => setModalVisible(false)}>
                                  Close
                                </Button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </ModalBody>
            </Modal>

          {/* Modal for Whatsapp Detail */}
            <Modal isOpen={wModalVisible} toggle={() => setModalVisible(!wModalVisible)} className="detailmodal-lg" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                <h5 >Whatsapp Detail</h5>  
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%'}}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '58%', marginRight: '2%', border: '2px solid #dcdcdc'}}>
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th style={{ paddingLeft: '10px' }} >Mobile No</th>
                          <th colSpan='2'style={{ paddingLeft: '10px' }} >Customer Name</th>
                          <th colSpan='2' style={{ paddingLeft: '10px' }} >Area </th>
                        </tr>
                      </thead>
                      <tbody className="scrollable-body">
                          {chekedNotify.map((row, index) => {
                              return (
                                <tr key={index} style={{ lineHeight: '10px' }} >
                                  <td className="cell-left"><span style={{ paddingLeft: '10px' }} >{row.custMo}</span></td>
                                  <td colSpan='2' className="cell-left"><span style={{ paddingLeft: '10px', fontSize: '14px' }} >{row.custEName}</span></td>
                                  <td colSpan='2' className="cell-left"><span style={{ paddingLeft: '10px', fontSize: '14px' }}>{row.custAreaEName}</span></td>
                                </tr>
                              );
                          })}
                      </tbody>
                      <tfoot>
                        <tr>
                          <th style={{ paddingLeft: '10px' }} >Total</th>
                          <th colSpan='2' className="cell-left"  style={{ paddingLeft: '10px' }} >{chekedNotify.length}</th>
                          <th colSpan='2' ></th>
                        </tr> 
                      </tfoot>
                    </table>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '40%', border: '2px solid #dcdcdc'}}>
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                      <tbody>
                        <tr>
                          <td className="cell-left">Gujarati</td>
                          <td className="cell-left">
                            <textarea 
                              value={gMsg} 
                              onChange={(e) => setGMsg(e.target.value)} 
                              rows="4" 
                            />
                          </td>
                        </tr>
                        <tr>
                          <td className="cell-left">English</td>
                          <td className="cell-left">
                            <textarea 
                              value={eMsg} 
                              onChange={(e) => setEMsg(e.target.value)} 
                              rows="4" 
                            />
                          </td>
                        </tr>
                        <tr>
                          <td className="cell-left">Image</td>
                          <td className="cell-left">
                            <input type="file" accept="image/*" onChange={(e) => handleImageChange(e)} />
                          </td>
                        </tr>
                        <tr>
                          <td colSpan='2'>
                            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                <Button color="success" style={{ flex: 1, marginLeft: '10px', marginRight: '10px'}} onClick={sendWMsgToServer}>
                                  Send
                                </Button>
                                <Button color="primary" style={{ flex: 1, marginLeft: '10px', marginRight: '10px' }} onClick={() => {setWModalVisible(false);  setSelectedImage(null); }}>
                                  Close
                                </Button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </ModalBody>
            </Modal>  



          {/* Modal for Customer Detail */}
            <Modal isOpen={custModalVisible} toggle={() => setModalVisible(!custModalVisible)} className="detailmodal" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                <h5 >Customer Detail</h5>  
                  <div >
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%' }}>
                      <tr>
                        <td style={{ padding: '2px' }} className="cell-left">ID : {selectedCustomer.custId}</td>
                        <td style={{ padding: '2px' }} className="cell-left">Mo No : {selectedCustomer.custMo}</td>
                      </tr>
                      <tr>
                        <td style={{ padding: '2px', fontSize: '14px', fontWeight: 'Bold' }} className="cell-left" >{selectedCustomer.custName}</td>
                        <td style={{ padding: '2px', fontSize: '14px', fontWeight: 'Bold' }} className="cell-left" >{selectedCustomer.custAdd}</td>
                      </tr>
                      <tr>
                        <td style={{ padding: '2px' }} className="cell-left">Notitication Send : </td>
                        <td style={{ padding: '2px' }} className="cell-left">
                              <span style={{display: 'flex', padding: '2px', alignItems: 'center'}}>
                                <span style={{  width: '10px', height: '10px', borderRadius: '50%', backgroundColor: selectedCustomer.custPNToken === 'android' ? '#00962d' : '#000000', marginRight: '5px', marginLeft: '10px'}}></span>
                                <span>{selectedCustomer.custPNToken === 'android' ? 'Android ' : 'ios '}</span>
                                <span style={{ marginLeft: '15px' }}>{selectedCustomer.custLang}</span>
                              </span>
                        </td>
                      </tr>
                      <tr>
                        <td style={{ padding: '2px' }} className="cell-left">Ref No : </td>
                        <td style={{ padding: '2px' }} className="cell-left">{selectedCustomer.custRefno}</td>
                      </tr>
                      <tr>
                        <td className="cell-left" style={{ padding: '2px' }}> Area</td>
                        <td style={{ padding: '2px' }} className="cell-left">{selectedCustomer.custAreaEName}</td>
                      </tr>
                      
                    </table>
                  </div>
                  <div >
                    <Button color="primary"  onClick={() => setCustModalVisible(false)}>
                      Close
                    </Button>
                  </div>
                
              </ModalBody>
            </Modal>  

    </div>
  );
};

export default NotifyMaster;
